import React from "react";
import { render } from "react-dom";
import PackagePage from "../widgets/package_page";


let packagePageElem = document.querySelector(".widget-package-page");
if (packagePageElem) render(<PackagePage elem={packagePageElem} />, packagePageElem);
